import styled from 'styled-components';
const ResultStyled = styled.div`
  flex: 1;
  padding: 24px 0;
  background-color: #fff;
  border-radius: 12px;
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .table-describe {
    padding: 0 32px;
    font-size: 14px;
    font-weight: 400;
    color: #636363;
    line-height: 20px;
    display: flex;
    align-items: center;
    .text {
      margin-left: auto;
      margin-right: 12px;
    }
    margin-bottom: 14px;
    .download {
      width: 80px;
    }
  }

  .button_group {
    padding-left: 32px;
  }
  .table {
    > div {
      padding-top: 0;
    }
  }
  .table-content {
    margin-top: 0;
  }
`;
export default ResultStyled;
